import * as React from 'react';
import {Stack, Typography, Box, Button} from "@mui/material";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

export default function GameButton({text, link, icon, img}) {
    const {mode} = useDarkMode();
    return (
        <Box className={'game_box'} sx={{backgroundColor : mode.settings.cardBackgroundColor}}>
            <Stack gap={1.5}>
                <Stack center direction={'row'} alignItems={"center"}>
                    <img src={icon} alt="" width={45} height={40}/>
                    <Typography sx={{color : mode.settings.textColor3}}  variant={"subtitle3"}>Jeux</Typography>
                </Stack>
                <Stack center alignItems={"center"}>
                    <img src={img} width={"100%"} height={"100%"} alt=""/>
                </Stack>
                <Typography sx={{color : mode.settings.textColor3}}  variant={"subtitle3"}>{text}</Typography>
                <Stack alignItems={"center"}>
                    <Button
                        className="btn-gradient"
                        style={{
                            width : "100%"
                        }}
                        onClick={() => window.open(link, "_blank")}
                    >
                        <Typography variant={'subtitle3'}>
                            Jouer
                        </Typography>

                    </Button>
                </Stack>
            </Stack>
        </Box>
    )
}
